module.exports = __webpack_public_path__ + "static/media/goodnest1.1bae4fab.jpg";